import { useForm } from 'react-hook-form';
import useRegister, { Register } from '../../api/hooks/authentication/useRegister';
import { settingsInputs } from '../../consts/inputs';
import { toIcons } from '../../consts/Paths';
import useIsMobile from '../../hooks/useIsMobile';
import { getInputs } from '../../utils/getMethods';
import CustomInput from '../inputs/CustomInput';
import { useEffect } from 'react';
import useLogMessage from '../../hooks/useLogMessage';
import useToggle from '../../hooks/useToggle';
import LogMessage from '../misc/LogMessage';
import { logMsgBgColors } from '../../consts/misc';
import useConditions from '../../api/hooks/useConditions';

const SettingsCreateConditionsModal = (props: any) => {
    const { CTAs, RESPONSES } = useConditions();
    const { isMobile } = useIsMobile();
    const createNewUserForm = useForm();
    const { write } = props.logMessage;

    const onSubmit = (data: any) => {
        /* console.log("calling: create new user form"); */
        CTAs.createCondition(data);
    };

    /* Setting Messsage */
    useEffect(() => {
        /* console.log(registerResponse, registerResult); */
        if (RESPONSES.createConditionsResponse?.ok) {
            write('subject', 'Condition ');
            write('other_text', 'has been added ');
            write('complement', 'successfully!');
            write('bgColor', logMsgBgColors.correct);
            props.toggler.toggle();
            props.resetList.toggle();
        } else if (RESPONSES.createConditionsResponse?.ok === false) {
            write('subject', 'Rule ');
            write('other_text', 'has not been addedd');
            write('complement', 'try again');
            write('bgColor', logMsgBgColors.error);
        }
    }, [RESPONSES.createConditionsResponse]);

    return (
        <div
            className='modal-wrapper'
            style={{
                height: `100vh`,
            }}
        >
            <div
                className='settings-edit-modal'
                style={{
                    width: isMobile ? '345px' : '',
                }}
            >
                <form onSubmit={createNewUserForm.handleSubmit(onSubmit)}>
                    <div className='settings-edit-modal-content' style={{ margin: isMobile ? '35px 19px 0 21px' : '' }}>
                        <div className='modal-header'>
                            <p className='modal-title'>Add condition</p>
                            <div className='Oval' onClick={props.toggler.toggle}>
                                <img src={`${toIcons}/close.svg`} />
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '25px',
                                marginTop: '22px',
                            }}
                        >
                            <CustomInput key={'name'} width={'100%'} title={'Nome'} name={'name'} type={'text'} register={createNewUserForm.register} errors={createNewUserForm.formState.errors} />
                            <CustomInput key={'notes'} width={'100%'} title={'Note'} name={'notes'} type={'text'} register={createNewUserForm.register} errors={createNewUserForm.formState.errors} />
                        </div>
                        <button
                            style={{
                                marginRight: '0',
                                width: isMobile ? '100%' : '105px',
                            }}
                            className='modal-button'
                            type='submit'
                        >
                            <p className='modal-button-text'>Add</p>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default SettingsCreateConditionsModal;
